import { MadSDKAPIError } from "../../errors/base";
export class InvalidStation extends MadSDKAPIError {
    constructor(errors, originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, InvalidStation);
        }
        this.name = "InvalidStation";
        this.message = `Provided station is invalid: ${errors.join(", ")}`;
    }
}
export class StationsFetchFailed extends MadSDKAPIError {
    constructor(error, fallback = "Failed to retrieve stations. Please try again at a later time.") {
        super(error);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, StationsFetchFailed);
        }
        this.name = "StationsFetchFailed";
        this.message = error?.response?.data?.message || fallback;
    }
}
export class StationSaveFailed extends MadSDKAPIError {
    constructor(error, fallback = "Failed to save station. Please try again at a later time.") {
        super(error);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, StationSaveFailed);
        }
        this.name = "StationSaveFailed";
        this.message = error?.response?.data?.message || fallback;
    }
}
//# sourceMappingURL=errors.js.map